import JsonLd from '@ecm/ui/seo/JsonLd'

type Author = {
  name: string
  url: string
}

type ArticleJsonLdProps = {
  author: Author
  url: string
  headline: string
  image: string
  description: string
  datePublished: string
  dateModified: string
}

const ArticleJsonLd = ({ url, author, ...other }: ArticleJsonLdProps) => {
  const structuredData = {
    author: { '@type': 'Person', ...author },
    mainEntityOfPage: {
      '@id': url,
      '@type': 'WebPage',
    },
    publisher: {
      '@type': 'Organization',
      logo: 'https://www.earthclassmail.com/images/logo/ecm-legal-zoom.svg',
      name: 'Earth Class Mail',
    },
    ...other,
  }

  return <JsonLd type="Article" structuredData={structuredData} />
}

export default ArticleJsonLd
